import { AssignedStoresTableProps } from "./assigned-stores-table.types";
// import styles from './assigned-stores-table.module.scss'
// import cl from 'classnames'
import {
  TableContainer,
  TableHeader,
  TableBodyContainer,
} from "@touche-lts/panel-ui/dist";
import { AssignedStoresTableBodyLine } from "./assigned-stores-table-body-line";
import { storesTableWidths } from "./assigned-stores-table.utils";
import { observer } from "mobx-react-lite";
import { useRootStore } from "mobx-stores/store-provider";
import cl from 'classnames'
import styles from './assigned-stores-table.module.scss'

const AssignedStoresTableComponent = (props: AssignedStoresTableProps) => {
  const { className, style } = props;
  const {
    userProfilePageStore: {
      assignedStores,
      userRolesLabel,
      onUnassignStoreClick,
    },
  } = useRootStore();

  return (
    <TableContainer
      noBoxShadow
      style={{ marginTop: 20, ...style, overflowX: 'auto' }}
      className={cl(className, styles.thinScroll)}
    >
      <TableHeader
        tableColumns={[
          {
            label: "id",
            widthPx: storesTableWidths.id,
            noFilter: true,
          },
          {
            label: "store",
            widthPx: storesTableWidths.store,
            noFilter: true,
          },
          {
            label: "role",
            widthPx: storesTableWidths.role,
            noFilter: true,
          },
        ]}
      />
      <TableBodyContainer style={{ minHeight: 0 }} className={styles.tableBodyContainer}>
        {assignedStores.map((store) => {
          return (
            <AssignedStoresTableBodyLine
              key={store.id}
              store={store}
              userRoleLabel={userRolesLabel}
              onUnassignClick={() => onUnassignStoreClick(store.id)}
            />
          );
        })}
      </TableBodyContainer>
    </TableContainer>
  );
};

const AssignedStoresTable = observer(AssignedStoresTableComponent);
export { AssignedStoresTable };
